import { gqlTypes } from '../types';
import * as types from '../types';
import { expectUnreachable } from './util';
import i18next from '../../i18n';

export function gqlBillingCadenceToBillingCadence(gqlBillingCadence: gqlTypes.BillingCadence): types.BillingCadence {
  switch (gqlBillingCadence) {
    case gqlTypes.BillingCadence.MONTH:
      return types.BillingCadence.Month;
    case gqlTypes.BillingCadence.YEAR:
      return types.BillingCadence.Year;
    case gqlTypes.BillingCadence.WEEK:
      return types.BillingCadence.Week;
    default:
      expectUnreachable(gqlBillingCadence);
      throw new Error(i18next.t('unknown_billing_cadence', { billingCadence: gqlBillingCadence }));
  }
}

export function commonDetailsForSubscription(subscription: types.ISubscriptionProduct): { subscriptionName: string } {
  if (subscription.freeTrial && subscription.freeTrialDays) {
    return {
      subscriptionName: i18next.t('free_trial_duration', {
        duration: getFreeTrialDurationLabel(subscription.freeTrialDays),
      }),
    };
  }

  const renewalMonths = subscription.renewalMonths;
  if (renewalMonths % 12 === 0) {
    const years = Math.round(renewalMonths / 12);
    return { subscriptionName: i18next.t('subscription_years_year', { years }) };
  }

  if (renewalMonths === 1) {
    return { subscriptionName: i18next.t('subscription_monthly') };
  }

  return { subscriptionName: i18next.t('subscription_months', { months: renewalMonths }) };
}

export function getFreeTrialDurationLabel(freeTrialDays: number): string {
  if (freeTrialDays % 30 === 0) {
    const months = freeTrialDays / 30;
    return i18next.t(months === 1 ? 'subscription_month' : 'subscription_months', { months });
  }
  return i18next.t('subscription_day', { days: freeTrialDays });
}
